export function onlyGene(rawDataCollection, gene) {
  let rawAlignments = rawDataCollection.rawAlignments;
  let rawSequences = rawDataCollection.rawSequences;

  rawAlignments = rawAlignments.map((ra) => {
    ra.geneSequences = ra.geneSequences.filter((ge) => {
      return ge.gene === gene;
    });
    return ra;
  });
  rawAlignments = rawAlignments.filter((ra) => {
    return ra.geneSequences.length > 0;
  });
  rawDataCollection.rawAlignments = rawAlignments;

  let rawSeqIds = rawAlignments.map((ali) => ali.rawSequenceUuid);

  rawSequences = rawSequences.filter((seq) => rawSeqIds.includes(seq.uuid));
  rawDataCollection.rawSequences = rawSequences;

  return rawDataCollection;
}



// WEBPACK FOOTER //
// ./src/views/wizard/isolate/gtable_seq/seq_ops.js